<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex
      v-bind="{ [`xs${viz.flex}`]: true }"
      v-for = "viz in visualizations"
      :key = 'viz.title'
      >
      <v-card>
        <v-container fluid grid-list-lg>
          <v-layout row>
            <v-flex xs5>
              <div class='title' v-text='viz.title'>
              </div>
          </v-flex>
          <v-flex>
            <v-card-media
            :src='viz.src'
            height = '100px'
            contain
            >
          </v-card-media>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
      <v-btn flat @click.native.stop='openVizDialog(viz)'> Open visualization </v-btn>
    </v-card-actions>
  </v-card>
</v-flex>
</v-layout>
<v-dialog v-model='dialog' fullscreen transition='dialog-bottom-transition' hide-overlay>
  <v-card>
    <v-toolbar class="theme--dark primary">
      <v-btn icon @click.native='closeVizDialog' dark>
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>{{$route.params.id}} Decagon Volumetric Water Content</v-toolbar-title>
    </v-toolbar>
    <router-view> </router-view>
  </v-card>
</v-dialog>
</v-container>
</template>

<script>
  export default {
    name: 'viz-selector',
    data () {
      return {
        visualizations: [
          { title: 'Decagon Volumetric Water Content', src: '/static/WxStationMapsCard.png', flex: 4 },
          { title: 'Land PKS Viewer', src: '/static/WellsCardImage2.png', flex: 4 }
        ],
        dialog: false
      }
    },
    mounted () {
      if (this.$route.name !== 'VisualizationSelector') {
        console.log(this.$route.name)
        this.$nextTick(() => {
          this.dialog = true
        })
      }
    },
    methods: {
      closeVizDialog () {
        this.dialog = false
        this.$router.replace('/project/' + this.$route.params.projectid + '/visualizations')
      },
      openVizDialog (viz) {
        console.log(viz)
        if (viz.title === 'Land PKS Viewer') {
          this.$router.push('/project/' + this.$route.params.projectid + '/visualizations/landpks')
        } else {
          this.$router.push('/project/' + this.$route.params.projectid + '/visualizations/vwc/station1')
        }

        this.dialog = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/visualization/VisualizationSelector.vue